<template>
    <div
        class="back-to-assignment-bank"
        v-if="preview">
        <b-button
            class="btn-back-to-overview btn-back"
            variant="outline-primary"
            @click="previewStatusUpdate">
            {{ $t('databank.back_to_overview') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-databank-back-to-overview-component',
    props: {
        previewIn: Boolean,
    },
    data() {
        return {
            preview: this.previewIn,
        };
    },

    methods: {
        previewStatusUpdate() {
            this.preview = !this.preview;
            this.$emit('preview-status-update', this.preview);
        },
    },

    watch: {
        previewIn: function (status) {
            this.preview = status;
        },
    },
};
</script>

<style scoped>
.back-to-assignment-bank {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.btn-back-to-overview {
    width: 100%;
}

@media (min-width: 540px) {
    .btn-back-to-overview {
        width: auto;
    }
}
</style>
